// @ts-nocheck
import _ from 'lodash';
import { ANNOTATION_TYPE } from '../../config';
import { getClosestChannelIndex } from '../../ui/helper';
import BeatComplexCalipers from './components/beatComplexCalipers';
import EventPosition from './components/eventPosition';
import HorizontalCaliper from './components/horizontalCaliper';
import NoiseEvent from './components/noiseEvent';
import RectangleSelection from './components/rectangleSelection';
import TextAnnotation from './components/textAnnotation';
import VerticalCaliper from './components/verticalCaliper';
import BeatSelection from './components/beatSelection';
import BeatIndicator from './components/beatIndicator';

let Annotations;

(function () {
  Annotations = function (canvas: any, config: any, verticalChannelPlacement: any) {
    this.annoArr = [];
    this.canvas = canvas;
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.selectedObj = null;
    this.isModifying = false;
    this.beatIndicator = null;
    this.beatSelection = null;
  };

  Annotations.prototype.draw = function (
    offsetX: any,
    channelIndex: any,
    type: any,
    p: any,
    bccObj: any,
  ) {
    switch (type) {
      case ANNOTATION_TYPE.HLINE: {
        // oxlint-disable-next-line import/no-named-as-default-member
        const hLine = new HorizontalCaliper.HorizontalCaliper(
          this.canvas,
          {
            x1: p.x,
            x2: p.x,
            y: p.y,
          },
          offsetX,
          this.config,
          this.verticalChannelPlacement,
          channelIndex,
        );
        this.annoArr.push(hLine);
        if (this.selectedObj) {
          this.selectedObj.deselect();
          this.selectedObj = null;
        }
        this.selectedObj = hLine;
        hLine.draw();
        hLine.select();
        this.prevPoint = p;
        break;
      }

      case ANNOTATION_TYPE.RECT_SELECT: {
        // oxlint-disable-next-line import/no-named-as-default-member
        const rectSelect = new RectangleSelection.RectangleSelection(
          this.canvas,
          {
            x1: p.x,
            x2: p.x,
            y1: p.y,
            y2: p.y,
          },
          offsetX,
          this.config,
          this.verticalChannelPlacement,
          channelIndex,
        );
        this.annoArr.push(rectSelect);
        this.selectedObj = rectSelect;
        rectSelect.draw();
        this.prevPoint = p;
        break;
      }

      case ANNOTATION_TYPE.VLINE: {
        // oxlint-disable-next-line import/no-named-as-default-member
        const vLine = new VerticalCaliper.VerticalCaliper(
          this.canvas,
          {
            x: p.x,
            y1: p.y,
            y2: p.y,
          },
          offsetX,
          this.config,
          this.verticalChannelPlacement,
          channelIndex,
        );
        this.annoArr.push(vLine);
        if (this.selectedObj) {
          this.selectedObj.deselect();
          this.selectedObj = null;
        }
        this.selectedObj = vLine;
        vLine.draw();
        vLine.select();
        this.prevPoint = p;
        break;
      }

      case ANNOTATION_TYPE.TEXT: {
        // oxlint-disable-next-line import/no-named-as-default-member
        const textAnno = new TextAnnotation.TextAnnotation(
          this.canvas,
          {
            x: p.x,
            y: p.y,
          },
          offsetX,
          this.config,
          this.verticalChannelPlacement,
          channelIndex,
        );
        this.annoArr.push(textAnno);
        if (this.selectedObj) {
          this.selectedObj.deselect();
          this.selectedObj = null;
        }
        this.selectedObj = textAnno;
        textAnno.draw();
        textAnno.select();
        break;
      }

      case ANNOTATION_TYPE.BCC: {
        // oxlint-disable-next-line import/no-named-as-default-member
        const bcc = new BeatComplexCalipers.BeatComplexCalipers(
          this.canvas,
          bccObj,
          offsetX,
          this.config,
          this.verticalChannelPlacement,
          channelIndex,
        );
        this.annoArr.push(bcc);
        if (this.selectedObj) {
          this.selectedObj.deselect();
          this.selectedObj = null;
        }
        bcc.draw();
        break;
      }

      default: {
        console.log('Invalid type');
        break;
      }
    }
    this.render();
  };

  Annotations.prototype.drawEventPosition = function (sampleIndex: any, offsetX: any) {
    // oxlint-disable-next-line import/no-named-as-default-member
    const eventPos = new EventPosition.EventPosition(
      this.canvas,
      sampleIndex,
      offsetX,
      this.config,
    );
    this.annoArr.push(eventPos);
    eventPos.draw();
    this.render();
  };

  //* Beat selection
  Annotations.prototype.drawBeatSelection = function (point: any, offsetX: any, isDelete: any) {
    // oxlint-disable-next-line import/no-named-as-default-member
    this.beatSelection = new BeatSelection.BeatSelection(
      this.canvas,
      {
        x1: point.x,
        x2: point.x,
        y1: point.y,
        y2: point.y,
      },
      offsetX,
      this.config,
      isDelete,
    );
    this.beatSelection.draw();
    this.prevPoint = point;
  };

  Annotations.prototype.scrollBeatSelection = function (offsetX: any) {
    if (this.beatSelection) {
      this.beatSelection.scroll(offsetX);
    }
  };

  Annotations.prototype.updateBeatSelection = function (
    point: any,
    isScrolling: any,
    leValue: any,
    isDelete: any,
  ) {
    if (this.beatSelection) {
      this.beatSelection.update(
        {
          dx: point.x - this.prevPoint.x,
          dy: point.y - this.prevPoint.y,
        },
        isScrolling,
        leValue,
        isDelete,
      );
      this.prevPoint = point;
    }
  };

  Annotations.prototype.deleteBeatSelection = function () {
    if (this.beatSelection) {
      this.beatSelection.delete();
      this.beatSelection = null;
    }
  };

  //* Beat indicator
  Annotations.prototype.drawBeatIndicator = function ({ beatTypeNumber }: any) {
    if (this.beatIndicator) {
      this.updateBeatIndicator({ beatTypeNumber });
      return;
    }
    // oxlint-disable-next-line import/no-named-as-default-member
    this.beatIndicator = new BeatIndicator.BeatIndicator(this.canvas, this.config, beatTypeNumber);
    this.beatIndicator.draw();
  };

  Annotations.prototype.updateBeatIndicator = function (objectUpdate: any) {
    if (this.beatIndicator) {
      this.beatIndicator.update(objectUpdate);
    }
  };

  Annotations.prototype.deleteBeatIndicator = function () {
    if (this.beatIndicator) {
      this.beatIndicator.delete();
      this.beatIndicator = null;
    }
  };

  Annotations.prototype.drawNoiseEvent = function (
    noiseEventsArray: any,
    offsetX: any,
    isAppliedAI: any,
  ) {
    /**
     * Selects the annotations of type NOISE_EVENT from the annotation array. Filters annoArr by ANNOTATION_TYPE.NOISE_EVENT.
     *
     * @returns The noise-event annotations.
     */
    const noiseEvents = _.filter(this.annoArr, (x) => x.type === ANNOTATION_TYPE.NOISE_EVENT);
    _.forEach(noiseEvents, (noiseEvent) => {
      this.canvas.remove(noiseEvent.rect);
      _.remove(this.annoArr, noiseEvent);
    });

    if (isAppliedAI) {
      _.forEach(noiseEventsArray, (event) => {
        // oxlint-disable-next-line import/no-named-as-default-member
        const noiseEvent = new NoiseEvent.NoiseEvent(this.canvas, event, offsetX, this.config);
        this.annoArr.push(noiseEvent);
        noiseEvent.draw();
      });
    }
  };

  Annotations.prototype.handleChangeDiagnosisLead = function (offsetX: any, noiseEventsArray: any) {
    /**
     * Selects the annotations of type NOISE_EVENT from the annotation array. Filters annoArr by ANNOTATION_TYPE.NOISE_EVENT.
     *
     * @returns The noise-event annotations.
     */
    const noiseEvents = _.filter(this.annoArr, (x) => x.type === ANNOTATION_TYPE.NOISE_EVENT);
    _.forEach(noiseEvents, (noiseEvent) => {
      this.canvas.remove(noiseEvent.rect);
      _.remove(this.annoArr, noiseEvent);
    });

    _.forEach(noiseEventsArray, (event) => {
      // oxlint-disable-next-line import/no-named-as-default-member
      const noiseEvent = new NoiseEvent.NoiseEvent(this.canvas, event, offsetX, this.config);
      this.annoArr.push(noiseEvent);
      noiseEvent.draw();
    });
  };

  Annotations.prototype.render = function () {
    if (this.selectedObj) {
      this.selectedObj.render();
    }
  };

  Annotations.prototype.update = function (
    point: any,
    isDrawing: any,
    displayedChannelsArr: any,
    isScrolling: any,
    leValue: any,
    beatMarkers: any,
    offsetX: any,
  ) {
    if (this.selectedObj) {
      switch (this.selectedObj.type) {
        case ANNOTATION_TYPE.HLINE: {
          this.selectedObj.update(
            {
              dx: point.x - this.prevPoint.x,
              dy: point.y - this.prevPoint.y,
            },
            isDrawing,
            displayedChannelsArr,
            isScrolling,
            leValue,
            beatMarkers,
            offsetX,
          );
          break;
        }

        case ANNOTATION_TYPE.VLINE:
          this.selectedObj.update(
            {
              dx: point.x - this.prevPoint.x,
              dy: point.y - this.prevPoint.y,
            },
            isDrawing,
            displayedChannelsArr,
          );
          break;

        case ANNOTATION_TYPE.RECT_SELECT: {
          this.selectedObj.update(
            {
              dx: point.x - this.prevPoint.x,
              dy: point.y - this.prevPoint.y,
            },
            isScrolling,
            leValue,
          );
          break;
        }

        case ANNOTATION_TYPE.TEXT: {
          if (!this.selectedObj.isEditing()) {
            this.selectedObj.update(
              {
                dx: point.x - this.prevPoint.x,
                dy: point.y - this.prevPoint.y,
              },
              displayedChannelsArr,
            );
          }
          break;
        }

        case ANNOTATION_TYPE.BCC: {
          this.selectedObj.update(
            { dx: point.x - this.prevPoint.x, dy: point.y - this.prevPoint.y },
            displayedChannelsArr,
          );
          break;
        }

        default: {
          console.log('Error at annotation.js, function: update');
          break;
        }
      }
      this.render();
      this.prevPoint = point;
    }
  };

  Annotations.prototype.updateConfig = function (
    config: any,
    offsetX: any,
    verticalChannelPlacement: any,
    displayedChannelsArr: any,
  ) {
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.annoArr.forEach((e: any) => {
      e.updateConfig(this.config, offsetX, this.verticalChannelPlacement, displayedChannelsArr);
    });
  };

  Annotations.prototype.updateChannelIndex = function (displayedChannelsArr: any) {
    let y;

    if (this.selectedObj) {
      switch (this.selectedObj.type) {
        case ANNOTATION_TYPE.HLINE:
        case ANNOTATION_TYPE.TEXT:
          y = this.selectedObj.y;
          break;

        case ANNOTATION_TYPE.VLINE:
          // *: Update channelIndex exactly as expectation
          y = this.selectedObj.y1 + (this.selectedObj.y2 - this.selectedObj.y1) / 2;
          break;

        default:
          break;
      }
    }

    if (!y) {
      return;
    }

    const channelIndex = getClosestChannelIndex(y, this.verticalChannelPlacement);
    this.selectedObj.updateChannelIdx(displayedChannelsArr[channelIndex], displayedChannelsArr);
  };

  Annotations.prototype.scroll = function (offsetX: any, displayedChannelsArr: any) {
    this.annoArr.forEach((e: any) => {
      e.scroll(offsetX, displayedChannelsArr);
    });
  };

  Annotations.prototype.selectObj = function (point: any) {
    if (this.selectedObj) {
      if (this.selectedObj.type === 'TextAnnotation' && this.selectedObj.text.text === '') {
        _.remove(this.annoArr, (x) => x === this.selectedObj);
      }
      if (this.selectedObj.type === ANNOTATION_TYPE.BCC) {
        this.selectedObj.isSelected(point);
      }
      this.selectedObj.deselect();
      this.selectedObj = null;
      this.isModifying = false;
    }
    for (let i = this.annoArr.length - 1; i >= 0; i -= 1) {
      if (this.annoArr[i].isVisible && this.annoArr[i].isSelected(point)) {
        // Cuong test
        // console.log(this.selectedObj, this.annoArr[i]);
        if (this.selectedObj && this.selectedObj !== this.annoArr[i]) {
          this.selectedObj.deselect();
          this.selectedObj = null;
        }
        this.selectedObj = this.annoArr[i];
        this.selectedObj.select();
        this.isModifying = true;
        this.prevPoint = point;
        break;
      }
    }
  };

  Annotations.prototype.selectObjByInstance = function (anno: any) {
    this.selectedObj = anno;
  };

  Annotations.prototype.deleteObj = function (isNotRemoveArr: any) {
    if (this.selectedObj) {
      if (
        this.selectedObj.type === ANNOTATION_TYPE.HLINE ||
        this.selectedObj.type === ANNOTATION_TYPE.VLINE
      ) {
        this.canvas.remove(
          this.selectedObj.l,
          this.selectedObj.le,
          this.selectedObj.ls,
          this.selectedObj.lt,
          this.selectedObj.lt1,
        );
      } else if (this.selectedObj.type === ANNOTATION_TYPE.BCC) {
        _.forEach(this.selectedObj.l, (l) => {
          this.canvas.remove(l);
        });
        _.forEach(this.selectedObj.labels, (label) => {
          this.canvas.remove(label);
        });
        this.canvas.remove(this.selectedObj.text);
      } else if (this.selectedObj.type === ANNOTATION_TYPE.TEXT) {
        this.canvas.remove(this.selectedObj.text);
      } else if (this.selectedObj.type === ANNOTATION_TYPE.RECT_SELECT) {
        this.canvas.remove(this.selectedObj.rect);
      }

      if (!isNotRemoveArr) {
        _.remove(this.annoArr, (x) => x === this.selectedObj);
        this.selectedObj = null;
      }
    }
  };

  Annotations.prototype.import = function (annotation: any) {
    if (!annotation) {
      console.log('Problem at annotation.js, function import: array have null object');
    } else {
      switch (annotation.type) {
        case ANNOTATION_TYPE.HLINE: {
          // oxlint-disable-next-line import/no-named-as-default-member
          const hLine = new HorizontalCaliper.HorizontalCaliper(
            this.canvas,
            { x1: 0, x2: 0, y: 0 },
            0,
            this.config,
            this.verticalChannelPlacement,
            0,
          );
          hLine.import(annotation);
          this.annoArr.push(hLine);
          break;
        }

        case ANNOTATION_TYPE.VLINE: {
          // oxlint-disable-next-line import/no-named-as-default-member
          const vLine = new VerticalCaliper.VerticalCaliper(
            this.canvas,
            { x: 0, y1: 0, y2: 0 },
            0,
            this.config,
            this.verticalChannelPlacement,
            0,
          );
          vLine.import(annotation);
          this.annoArr.push(vLine);
          break;
        }

        case ANNOTATION_TYPE.TEXT: {
          // oxlint-disable-next-line import/no-named-as-default-member
          const textAnno = new TextAnnotation.TextAnnotation(
            this.canvas,
            { x: 0, y: 0 },
            0,
            this.config,
            this.verticalChannelPlacement,
            0,
          );
          textAnno.import(annotation);
          this.annoArr.push(textAnno);
          break;
        }

        case ANNOTATION_TYPE.BCC: {
          // oxlint-disable-next-line import/no-named-as-default-member
          const bcc = new BeatComplexCalipers.BeatComplexCalipers(
            this.canvas,
            annotation.xr,
            0,
            this.config,
            this.verticalChannelPlacement,
            annotation.channelIndex,
          );
          bcc.import(annotation);
          this.annoArr.push(bcc);
          break;
        }

        default:
          console.log('Error annotation.js, function import: Unexpected type: ', annotation.type);
          break;
      }
    }
  };

  Annotations.prototype.getJSONArr = function (): any {
    const obj: any = [];
    this.annoArr.forEach((e: any) => {
      obj.push(e.getJSONObject());
    });
    return obj;
  };
})();

export { Annotations };
export default { Annotations };
